import React, { useEffect, useState } from 'react';
import { useLocation, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './CategorySelector.css';

const apiUrl = process.env.REACT_APP_API_URL;

const CategorySelector = ({ user }) => {
  const [currentIndexes, setCurrentIndexes] = useState({});
  const navigate = useNavigate();

  const location = useLocation();
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [categories, setCategories] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const [parentCategoriesWithImages, setParentCategoriesWithImages] = useState([]); // New state for parent categories with images
  const [mediaData, setMediaData] = useState([]); // State to hold media data for ImageViewer
  const [token] = useState(localStorage.getItem('token') || '');

  const [thumbnailsCache, setThumbnailsCache] = useState({}); // { [categoryId]: [urls] }

  const fetchImagesForCategory = async (categoryId) => {
    if (thumbnailsCache[categoryId]) {
      return thumbnailsCache[categoryId];
    }

    try {
      const response = await fetch(`${apiUrl}/images/category/${categoryId}?limit=5`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Backend már a kész thumbnail URL-eket adja vissza
      const imageUrls = await response.json();

      setThumbnailsCache(prev => ({ ...prev, [categoryId]: imageUrls }));
      return imageUrls;

    } catch (error) {
      console.error(`Error fetching images for category ${categoryId}:`, error);
      return [];
    }
  };



  const fetchCategories = async () => {
    try {
      const response = await fetch(`${apiUrl}/categories`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();

      setCategories(data);
      const filteredParentCategories = data.filter((cty) => cty.parent_id === null);
      setParentCategories(filteredParentCategories);

      const categoriesWithImages = await Promise.all(filteredParentCategories.map(async (cat) => {
        const images = await fetchImagesForCategory(cat.id);
        return { ...cat, images: images || [] };
      }));
      setParentCategoriesWithImages(categoriesWithImages); // Set the new state


    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [token]); // Fetch categories on component mount or when token changes

  // Időzített képváltás minden kategóriára
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexes((prev) => {
        const next = { ...prev };
        parentCategoriesWithImages.forEach(cat => { // Use the new state
          const current = prev[cat.id] ?? 0;
          next[cat.id] = (cat.images && cat.images.length > 0) ? (current + 1) % cat.images.length : 0;
        });
        return next;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, [parentCategoriesWithImages]); // Re-run when parentCategoriesWithImages change

  const handleSelectCategory = (category) => {
    navigate('/images/list', { state: { selectedCategory: category.name } });
  };

  return (
    <div className="category-selector">
      {parentCategoriesWithImages.map((cat) => (
        <div key={cat.id} className="category-item">

          <div
            className={`category-tile ${!cat.images?.length ? 'loading' : ''}`}
            onClick={() => handleSelectCategory(cat)}
            style={{
              backgroundImage:
                cat.images?.length
                  ? `url(${cat.images[currentIndexes[cat.id] ?? 0]})`
                  : 'none'
            }}
          >
          </div>

          <h2 className="category-label">{cat.name}</h2>
        </div>
      ))}
    </div>
  );
};

export default CategorySelector;
